const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-1004.3622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 44.999995,1028.357 c -0.028,-0.715 -0.3223,-1.5414 -0.8125,-2.0626 l -16,-17.0008 c -1.0842,-0.9743 -3.1632,-1.3765 -4.375,-0.25 -1.1936,1.1095 -1.1581,3.2613 0.031,4.3752 l 11.25,11.9381 -29.0934997,0 c -1.6568,0 -3,1.3432 -3,3.0001 0,1.6569 1.3432,3.0001 3,3.0001 l 29.0934997,0 -11.25,11.9381 c -1.0237,1.0255 -1.2129,3.253 -0.031,4.3752 1.1816,1.1221 3.3353,0.7636 4.375,-0.2501 l 16,-17.0007 c 0.5475,-0.5818 0.8143,-1.2644 0.8125,-2.0626 z",
    style: {
      textIndent: 0,
      textTransform: "none",
      direction: "ltr",
      blockProgression: "tb",
      baselineShift: "baseline",
      enableBackground: "accumulate"
    },
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    marker: "none",
    visibility: "visible",
    display: "inline",
    overflow: "visible"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowRight);
export default __webpack_public_path__ + "static/media/icon-arrow-right.99e59b03.svg";
export { ForwardRef as ReactComponent };